import { BADGE_SIZE, ICON_COLOR, ICON_SIZE } from './tokens';
export const badgeSize = ({ size }) => typeof size === 'number' ? size : BADGE_SIZE[size];
export const iconColor = ({ colorway = 'default', strength = 'strong', iconColor, }) => (iconColor ? iconColor : ICON_COLOR[colorway][strength]);
export const iconSize = ({ iconSize, size = 'lg', }) => {
    if (iconSize)
        return iconSize;
    return typeof size === 'number' ? size - 4 : ICON_SIZE[size];
};
